import { Input, Button, Form } from "antd";

const ChangePassword = () => (
  <Form layout="vertical">
    <Form.Item label="Mevcut Şifre" name="currentPassword">
      <Input.Password />
    </Form.Item>
    <Form.Item label="Yeni Şifre" name="newPassword">
      <Input.Password />
    </Form.Item>
    <Form.Item label="Yeni Şifre (Tekrar)" name="confirmPassword">
      <Input.Password />
    </Form.Item>
    <Button type="primary" htmlType="submit">
      Şifreyi Değiştir
    </Button>
  </Form>
);
export default ChangePassword;
